var map = {
	"./AdminIcon.svg": 64515,
	"./DashboardIcon.svg": 27595,
	"./Notification.svg": 11253,
	"./PLAN.svg": 31436,
	"./PortfolioIcon.svg": 39092,
	"./ProjectIcon.svg": 83033,
	"./SETTING.svg": 85627,
	"./active-icons/ActiveAdminIcon.svg": 86594,
	"./active-icons/ActiveDashIcon.svg": 2198,
	"./active-icons/ActivePortfolioIcon.svg": 38244,
	"./active-icons/ActiveProjectIcon.svg": 31574,
	"./active-icons/Notification.svg": 53552,
	"./active-icons/PLAN.svg": 54874,
	"./active-icons/SETTING.svg": 23379,
	"./active-icons/message.svg": 1186,
	"./blue-graph.svg": 12904,
	"./green-graph.svg": 87051,
	"./hamsalogo.svg": 89510,
	"./kosoft-logo.svg": 26473,
	"./lightblue-graph.svg": 14871,
	"./message.svg": 2525,
	"./newlogo.svg": 41801,
	"./shortLogo.svg": 11963,
	"./yellow-graph.svg": 36166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;